import { createFileRoute } from '@tanstack/react-router';
import { UnderConstruction } from '@/shared/components/UnderConstruction';

export const Route = createFileRoute('/_backoffice/credit/')({
    component: () => (
        <UnderConstruction title="Home" hint="Dashboard del portal de crédito — próximamente." />
    ),
});
